/**
 * MagicStar UAE — Customer Reviews Data
 *
 * Edit this file to add, update, or remove reviews.
 * Each review object supports:
 *   author   {string}  — Reviewer name
 *   rating   {number}  — 1–5 stars
 *   date     {string}  — Display date (e.g. "March 2025")
 *   title    {string}  — Review headline
 *   body     {string}  — Review text
 *   verified {boolean} — Show "Verified Purchase" badge
 *
 * When you install a reviews app (Judge.me, Loox, etc.) these custom
 * reviews will automatically be replaced by the app's real reviews.
 */

window.MagicStarReviews = [
  {
    author: "Ahmed Al Mansoori",
    rating: 5,
    date: "February 2025",
    title: "Perfect for family gatherings!",
    body: "We use this every weekend for our family karaoke nights. The sound quality is crystal clear, setup took less than 5 minutes, and the wireless mics work flawlessly across the whole room. Best purchase I have made this year!",
    verified: true
  },
  {
    author: "Sarah K.",
    rating: 5,
    date: "January 2025",
    title: "Best karaoke system in the UAE",
    body: "I have tried several karaoke systems before and this is by far the best available in the UAE. The Bluetooth connection is rock solid, battery life is amazing, and the audio is powerful without any distortion. Absolutely love it.",
    verified: true
  },
  {
    author: "Mohammed Al Rashidi",
    rating: 5,
    date: "March 2025",
    title: "Same-day delivery and works great!",
    body: "Ordered at 10 AM, arrived by 3 PM — exactly as promised. The system was super easy to set up and the sound fills the entire living room. My whole family is obsessed with it. Will definitely buy another one as a gift.",
    verified: true
  },
  {
    author: "Priya Sharma",
    rating: 4,
    date: "December 2024",
    title: "Great product, minor learning curve",
    body: "Took about 10 minutes to figure out the mic pairing but once connected it was absolutely flawless. Sound is loud and clear, the LED lights look great in a dark room. Would definitely recommend to friends and family.",
    verified: true
  },
  {
    author: "Fatima Al Zaabi",
    rating: 5,
    date: "January 2025",
    title: "Amazing Eid gift — family loved it!",
    body: "Bought this as an Eid gift and the family absolutely loved it. The quality feels premium, the design is sleek, and the performance is outstanding. We have had multiple karaoke nights already. Great value for the price.",
    verified: true
  },
  {
    author: "James Thompson",
    rating: 5,
    date: "November 2024",
    title: "Outstanding build quality",
    body: "The build quality is excellent — feels very solid and premium. Sound is powerful enough for a large room with zero distortion even at high volumes. Customer service was also top-notch when I had a small query. Highly impressed.",
    verified: true
  },
  {
    author: "Layla M.",
    rating: 5,
    date: "February 2025",
    title: "My kids haven't stopped using it!",
    body: "Bought this for my kids and they are obsessed! The voice effects are hilarious and the microphones work really well even when they run around the room. Delivery was super fast. Wish I had bought it sooner!",
    verified: true
  },
  {
    author: "Khalid Al Hamadi",
    rating: 4,
    date: "January 2025",
    title: "Solid product, fast delivery",
    body: "Product is exactly as described and delivery was very fast — same day as promised. Bluetooth range is great throughout my apartment. The battery lasts way longer than expected. Happy with the purchase overall.",
    verified: true
  },
  {
    author: "Rania Youssef",
    rating: 5,
    date: "March 2025",
    title: "Every party needs one of these",
    body: "This has completely transformed our house parties. Everyone takes turns singing and the sound quality makes even average singers sound good! Ordered a second one for my parents. Delivery and packaging were perfect.",
    verified: true
  },
  {
    author: "David Fernandez",
    rating: 5,
    date: "October 2024",
    title: "Worth every dirham",
    body: "I was hesitant at first but this product exceeded all my expectations. The sound is rich and loud, the mics are responsive, and the Bluetooth pairing is instant every time. Would give it 6 stars if I could.",
    verified: true
  }
];
